<template>
    <div id="landlord">
        <div class="landlord-nav">
            <landlord-menu></landlord-menu>
        </div>
        <div class="landlord-wrap">
            <tool-bar></tool-bar>
            <!-- <div class="home-banner" v-if="$route.name === 'housestatusdefault'">
                <a href="https://flypig-public.s3-ap-southeast-1.amazonaws.com/advertisement/fly_pig_obis/index.html" target="_blank" rel="noopener noreferrer">
                    <img src="@/assets/img/obis/obis.png" alt="">
                </a>
            </div> -->
            <loading-animation v-if="loadingState == 1"></loading-animation>
            <transition v-else name="fade"> 
                <router-view ></router-view>
            </transition> 
        </div>
    </div>
</template>
<script>
import Menu from '@/components/landlord/Menu.vue'
import ToolBar from '@/components/landlord/ToolBar.vue';
import LoadingAnimation from '@/components/widge/LoadingAnimation.vue';
import { mapGetters } from 'vuex'

export default {
    name: 'LandLord',
    data () {
        return {

        }
    },
    created(){
        this.$store.dispatch('getUserStatus');
    },
    computed: {
        ...mapGetters({
            loadingState: 'GET_LOADING_STATE',
        })
    },
    components: {
        'landlord-menu': Menu,
        ToolBar,
        LoadingAnimation
    }
}
</script>
<style lang="scss" scoped>
    #landlord{
        position: relative;
        display: flex;
        .landlord-nav{
            position: relative;
        }
        .landlord-wrap{
            position: relative;
            width: 100%;
            margin-left: 186px;
            background: #f6f6f6;
            .home-banner{
                display: flex;
                align-items: center;
                justify-content: center;
                background: url('../../assets/img/obis/bg.svg');
                height: 60px;
                margin-bottom: -15px;
            }
        }
    }
    @media screen and (max-width: 1280px) {
        #landlord{
            .landlord-wrap{
                margin-left: 85px;
            }
        }
    }

</style>


// WEBPACK FOOTER //
// src/pages/landlord/LandLord.vue